import { render, staticRenderFns } from "./distribution-again.vue?vue&type=template&id=6c185eaf&scoped=true&"
import script from "./distribution-again.vue?vue&type=script&lang=js&"
export * from "./distribution-again.vue?vue&type=script&lang=js&"
import style0 from "./distribution-again.vue?vue&type=style&index=0&id=6c185eaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c185eaf",
  null
  
)

export default component.exports